import { AudioCreateInput, AudioUpdateInput } from "../../api";
import { builder } from "../builder";

builder.input<AudioCreateInput>("AudioCreateInput", {
  name: builder.string().required(),
  entry: builder.string().uuid().required(),
  image: builder.string().uuid().nullable(),
});

builder.input<AudioUpdateInput>("AudioUpdateInput", {
  name: builder.string(),
  entry: builder.string().uuid(),
  image: builder.string().uuid(),
});
